<template>
    <div>
        <div class="row">
            <div class="col-lg-12">
                <div class="wrapper wrapper-content animated fadeInUp">
                    <div class="ibox">
                        <div class="ibox-title">
                            <h5>Uploads</h5>
                        </div>
                        <div class="ibox-content">
                            <div class="row m-b-sm m-t-sm">
                                <div class="ibox">
                                    <div class="ibox-content">
                                        <div class="row m-b-sm m-t-sm">
                                            <table class="table table-hover">
                                                <thead>
                                                    <tr>
                                                        <th>Time</th>
                                                        <th>Uploader</th>
                                                        <th>Shells</th>
                                                        <th>New</th>
                                                        <th>Old</th>
                                                        <th>Bad</th>
                                                        <th>WPs</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-if="uploads" v-for="upload in uploads" :key="upload.id">
                                                      <td><router-link :to="{path:'/xs/upload/' + upload.id}">{{ $moment(upload.time.date).format('D.MM.Y HH:mm') }}</router-link></td>
                                                        <td>{{ upload.user.username }}</td>
                                                        <td>{{ upload.new + upload.old + upload.bad }}</td>
                                                        <td style="color: forestgreen;">{{ upload.new || 0 }}</td>
                                                        <td style="color: orange;">{{ upload.old || 0 }}</td>
                                                        <td style="color: red;">{{ upload.bad || 0 }}</td>
                                                        <td>
                                                          <strong>{{ upload.wpCount || 0 }}</strong>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
export default {
  data () {
    return {
      name: 'Uploads',
      uploads: []
    }
  },
  mounted () {
    this.loadUploads()
  },
  methods: {
    loadUploads () {
      axios.get('/xs/new-uploads')
        .then(r => {
          this.uploads = r.data
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Xs/Uploads.vue